import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {
    makeStyles,
    createMuiTheme,
    ThemeProvider,
  } from "@material-ui/core/styles";

import logo from '../logos/transparentgreylogo.png';

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
  },
  logo: {
    width: 'auto',
    height: '10vh',
    marginBottom: theme.spacing(1),
  },
  version: {
    fontSize: "5px",
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <Box className={classes.footer}>
      <img src={logo} alt="Logo" className={classes.logo} />
      <Typography variant="body2" className={classes.version}>
        Version 1.0.0
      </Typography>
    </Box>
  );
};

export default Footer;
